/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/fragments-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/fragments-api-client";
import type { CfrTranscodingGetCfrTranscodingJobStatusQueryResponse, CfrTranscodingGetCfrTranscodingJobStatusPathParams } from "../models/CfrTranscodingGetCfrTranscodingJobStatus";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { cfrTranscodingGetCfrTranscodingJobStatus } from "../axios/cfrTranscodingGetCfrTranscodingJobStatus";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const cfrTranscodingGetCfrTranscodingJobStatusQueryKey = (fragmentId: CfrTranscodingGetCfrTranscodingJobStatusPathParams["fragmentId"]) => ["fragments-api", { url: '/cfr-transcoding/:fragmentId/status', params: {fragmentId:fragmentId} }] as const

export type CfrTranscodingGetCfrTranscodingJobStatusQueryKey = ReturnType<typeof cfrTranscodingGetCfrTranscodingJobStatusQueryKey>

export function cfrTranscodingGetCfrTranscodingJobStatusQueryOptions(fragmentId: CfrTranscodingGetCfrTranscodingJobStatusPathParams["fragmentId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = cfrTranscodingGetCfrTranscodingJobStatusQueryKey(fragmentId)
  return queryOptions<CfrTranscodingGetCfrTranscodingJobStatusQueryResponse, ResponseErrorConfig<Error>, CfrTranscodingGetCfrTranscodingJobStatusQueryResponse, typeof queryKey>({
   enabled: !!(fragmentId),
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return cfrTranscodingGetCfrTranscodingJobStatus(fragmentId, config)
   },
  })
}

/**
 * @summary Get CFR transcoding job status for a fragment
 * {@link /cfr-transcoding/:fragmentId/status}
 */
export function useCfrTranscodingGetCfrTranscodingJobStatus<TData = CfrTranscodingGetCfrTranscodingJobStatusQueryResponse, TQueryData = CfrTranscodingGetCfrTranscodingJobStatusQueryResponse, TQueryKey extends QueryKey = CfrTranscodingGetCfrTranscodingJobStatusQueryKey>(fragmentId: CfrTranscodingGetCfrTranscodingJobStatusPathParams["fragmentId"], options: 
{
  query?: Partial<QueryObserverOptions<CfrTranscodingGetCfrTranscodingJobStatusQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? cfrTranscodingGetCfrTranscodingJobStatusQueryKey(fragmentId)

  const query = useQuery({
   ...cfrTranscodingGetCfrTranscodingJobStatusQueryOptions(fragmentId, config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}